import { type LoaderFunctionArgs, redirect } from "react-router";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

import storage from "@application/utilities/storage";

export const DASHBOARD_ORGANIZATION_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const oid = requireParam(props.params, "id");

  client.clearStore();
  client.resetStore();

  storage.set("oid", oid);

  return redirect("/dashboard");
};
